import React from "react";
import { useTranslation } from "react-i18next";
import "./text-area.scss";

function TextAreaAtom(props) {
	const {
		label,
		className,
		placeholder,
		value,
		onChange,
		error = "",
		required = false,
		errorTextPlaceholder = {},
		...rest
	} = props;
	const { t } = useTranslation();
	return (
		<div className="text-area-wrapper">
			{label && (
				<label>
					{label}
					{required && <span className="text-danger"> *</span>}
				</label>
			)}
			<textarea
				value={value}
				className={`form-control${error ? " is-invalid" : ""}${className ? " " + className : ""}`}
				placeholder={placeholder ?? ""}
				onChange={onChange}
				{...rest}
			/>
			{error && (
				<p className="text-area-error">{t(error, errorTextPlaceholder)}</p>
			)}
		</div>
	);
}

export default TextAreaAtom;
